import { PORTFOLIO_TABS_NAME } from '../../constants/reports/reports-data';

export const RISK_SETTINGS_VOL_SHOCKS = [
  { value: '-0.75', label: '-75%' },
  { value: '-0.5', label: '-50%' },
  { value: '-0.25', label: '-25%' },
  { value: '-0.1', label: '-10%' },
  { value: '0', label: '0%', isDefault: true },
  { value: '0.1', label: '+10%' },
  { value: '0.25', label: '25%' },
  { value: '0.5', label: '50%' },
  { value: '0.75', label: '75%' },
  { value: '1.0', label: '100%' },
  { value: '1.25', label: '125%' },
  { value: '1.5', label: '150%' },
];

export const RISK_SETTINGS_TIMES = [
  { value: '0D', label: 'T+0', isDefault: true },
  { value: '1D', label: 'T+1' },
  { value: '2D', label: 'T+2' },
  { value: '3D', label: 'T+3' },
  { value: '4D', label: 'T+4' },
  { value: '5D', label: 'T+5' },
];

export const PORTFOLIO_TABS_KEYS = [
  { key: PORTFOLIO_TABS_NAME.spotLadder, label: 'Spot Ladder' },
  { key: PORTFOLIO_TABS_NAME.spotGrid, label: 'Spot Vol Shock Grid' },
  { key: PORTFOLIO_TABS_NAME.spotTime, label: 'Spot Time Grid' },
  { key: PORTFOLIO_TABS_NAME.pnlLegacy, label: 'Legacy PNL' },
  { key: PORTFOLIO_TABS_NAME.pnl, label: 'PNL' },
  {
    key: PORTFOLIO_TABS_NAME.positionsAndOrders,
    label: 'Positions and Orders',
  },
  { key: PORTFOLIO_TABS_NAME.transactions, label: 'Transactions' },
  { key: PORTFOLIO_TABS_NAME.strikeReport, label: 'Strike Report' },
];

export const DATA_DISPLAY_KEYS = {
  perAccount: 'per_account',
  aggregated: 'aggregated',
};
